import script from "./JaMaterialSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./JaMaterialSelect.vue?vue&type=script&setup=true&lang=js"

import "./JaMaterialSelect.vue?vue&type=style&index=0&id=031b7af7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-031b7af7"]])

export default __exports__